import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsPageComponent } from './reports-page/reports-page.component';
import { ArticleContainerModule } from '../../shared/components/article-container/article-container.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import {CardsModule} from '../../shared/components/cards/cards.module';

@NgModule({
  declarations: [ReportsPageComponent],
  imports: [CommonModule, ArticleContainerModule, TranslateModule, CardsModule]
})
export class ReportsPageModule {}
